module.exports = __webpack_public_path__ + "static/media/scan-qr.a4b0c505.jpg";